import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  IClaimId,
  ICoveragesAndDiscountsResponse,
  IGetBillingTransactionsRequestParams,
  IGetBillingTransactionsResponse,
  IGetLienHolderRequestParams,
  IGetLienHolderResponse,
  IGetPoliciyActivitiesRequestParams,
  IGetPolicyActivitiesResponse,
  IGetPolicyClaimsTransactionsResponse,
  IGetPolicyCoveragesAndDiscountsRequestParams,
  IGetPolicyDetailsHeaderRequestParams,
  IGetPolicyRisksRequestBody,
  IGetPolicyRisksResponse,
  IPolicyDetailsHeaderResponse,
} from "../../../models/user/policyDetails/PolicyDetails";
import {
  API_GET_BILLING_TRANSACTIONS,
  API_GET_DOCUMENT_CONTENT,
  API_GET_VIEW_OR_DOWNLOAD_DOCUMENT_PA,
  API_POST_BILLING_DETAILS,
  API_POST_COVERAGES_AND_COVERAGES,
  API_POST_DOCUMENTS,
  API_POST_LEIN_HOLDERS,
  API_POST_POLICY_ACTIVITIES,
  API_POST_POLICY_CLAIMS_ACTIVITIES,
  API_POST_POLICY_DETAILS_HEADER,
  API_POST_POLICY_RISKS,
} from "../../../Apis/ApiEndPoints";
import {
  IDocumentContentRequest,
  IDocumentResponse,
  IDocumentsRequestParams,
} from "../../../models/user/policyDetails/Document";
import { CustomAction } from "../../customAction";
import {
  IBillingRequestParams,
  IBillingRequestPayloadList,
  IBillingResponse,
} from "../../../models/user/policyDetails/Billings";
import { Api } from "../../..";

export const GetPolicyDetailsHeader = createAsyncThunk(
  "policyDetails/GetPolicyDetailsHeader",
  async (requestParams: IGetPolicyDetailsHeaderRequestParams, { dispatch }) => {
    const response: IPolicyDetailsHeaderResponse = await CustomAction(
      Api.post(API_POST_POLICY_DETAILS_HEADER, requestParams),
      dispatch,
      "policyDetails/GetPolicyDetailsHeader"
    );
    return response;
  }
);

export const GetPolicyActivities = createAsyncThunk(
  "policyDetails/GetGetPolicyActivities",
  async (requestParams: IGetPoliciyActivitiesRequestParams, { dispatch }) => {
    const response: IGetPolicyActivitiesResponse = await CustomAction(
      Api.post(API_POST_POLICY_ACTIVITIES, requestParams),
      dispatch,
      "policyDetails/GetGetPolicyActivities"
    );
    return response;
  }
);

export const GetPolicyClaimsTransactions = createAsyncThunk(
  "policyDetails/GetPolicyClaimsTransactions",
  async (claimIds: IClaimId[], { dispatch }) => {
    const response: IGetPolicyClaimsTransactionsResponse = await CustomAction(
      Api.post(API_POST_POLICY_CLAIMS_ACTIVITIES, claimIds),
      dispatch,
      "policyDetails/GetPolicyClaimsTransactions"
    );
    return response;
  }
);

export const GetBillingTransactions = createAsyncThunk(
  "policyDetails/GetBillingTransactions",
  async (
    {
      accountId,
      carrier,
      system,
      lobCode,
    }: IGetBillingTransactionsRequestParams,
    { dispatch }
  ) => {
    const response: IGetBillingTransactionsResponse = await CustomAction(
      Api.post(API_GET_BILLING_TRANSACTIONS, {
        accountId,
        carrier,
        system,
        lobCode,
      }),
      dispatch,
      "policyDetails/GetBillingTransactions"
    );
    return response;
  }
);

export const GetPolicyCoveragesAndDiscounts = createAsyncThunk(
  "policyDetails/GetPolicyCoveragesAndDiscounts",
  async (
    requestParams: IGetPolicyCoveragesAndDiscountsRequestParams,
    { dispatch }
  ) => {
    const response: ICoveragesAndDiscountsResponse = await CustomAction(
      Api.post(API_POST_COVERAGES_AND_COVERAGES, requestParams),
      dispatch,
      "policyDetails/GetPolicyCoveragesAndDiscounts"
    );
    return response;
  }
);

export const GetPolicyRisks = createAsyncThunk(
  "policyDetails/GetPolicyRisks",
  async (requestParams: IGetPolicyRisksRequestBody, { dispatch }) => {
    const response: IGetPolicyRisksResponse = await CustomAction(
      Api.post(API_POST_POLICY_RISKS, requestParams),
      dispatch,
      "policyDetails/GetPolicyRisks"
    );
    return response;
  }
);

export const GetInsuranceDocuments = createAsyncThunk(
  "policyDetails/GetPolicyDocuments",
  async (requestParams: IDocumentsRequestParams[], { dispatch }) => {
    const response: IDocumentResponse = await CustomAction(
      Api.post(API_POST_DOCUMENTS, requestParams),
      dispatch,
      "policyDetails/GetPolicyDocuments"
    );
    return response;
  }
);

export const GetInsuranceDocumentContent = createAsyncThunk(
  "policyDetails/GetPolicyDocumentContent",
  async (requestParams: IDocumentContentRequest, { dispatch }) => {
    const response: any = await CustomAction(
      Api.get(
        `${API_GET_DOCUMENT_CONTENT}/${requestParams.policyId}/${requestParams.documentId}`,
        { responseType: "arraybuffer" }
      ),
      dispatch,
      "GetPolicyDocumentContent"
    );

    return response;
  }
);

export const VieworDownloadMockupDocumentsPA = createAsyncThunk(
  "policyDetails/GetPolicyDocumentContent",
  async (requestParams: IDocumentContentRequest, { dispatch }) => {
    const response: any = await CustomAction(
      Api.get(
        `${API_GET_VIEW_OR_DOWNLOAD_DOCUMENT_PA}/${
          requestParams.policyId
        }/${requestParams.lobCode?.toUpperCase()}_${requestParams.docType}`,
        {
          responseType: "arraybuffer",
        }
      ),
      dispatch,
      "GetPolicyDocumentContent"
    );
    return response;
  }
);

export const GetLienHolders = createAsyncThunk(
  "policyDetails/GetLienHolders",
  async (requestParams: IGetLienHolderRequestParams, { dispatch }) => {
    const response: IGetLienHolderResponse = await CustomAction(
      Api.post(API_POST_LEIN_HOLDERS, requestParams),
      dispatch,
      "policyDetails/GetLienHolders"
    );
    return response;
  }
);

export const GetPolicyBillingDetails = createAsyncThunk(
  "billingDetails",
  async (requestParams: IBillingRequestPayloadList, { dispatch }) => {
    const response: IBillingResponse = await CustomAction(
      Api.post(API_POST_BILLING_DETAILS, requestParams),
      dispatch,
      "billingDetails"
    );
    return response;
  }
);
